/** MCP personal access tokens (block 27). */
import { createdMcpTokenSchema, mcpTokenListSchema } from "@nook/schema";
export function listMcpTokens(http) {
    return http.request({ path: "/v1/mcp-tokens", schema: mcpTokenListSchema });
}
/** The only response that ever carries `token` and `connectorUrl`. */
export function createMcpToken(http, name) {
    return http.request({ path: "/v1/mcp-tokens", method: "POST", body: { name }, schema: createdMcpTokenSchema });
}
/** `204` whether or not the token was still active. */
export function revokeMcpToken(http, id) {
    return http.request({ path: `/v1/mcp-tokens/${id}`, method: "DELETE", schema: { parse: () => undefined } });
}
//# sourceMappingURL=mcp-tokens.js.map